export default __webpack_public_path__ + "asset/img/icon-delete@2x~43e2ee08.png";